// TawkWrapper.tsx
import React, { useEffect } from "react";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import { useStore } from "@/stores/store.js";

const capitalize = (s = "") =>
  s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

const TawkWrapper = () => {
  const { tokenParsed } = useStore();

  useEffect(() => {
    if (!tokenParsed) return;

    // Log everything so you can inspect it locally
    // console.log("[Keycloak tokenParsed]:", tokenParsed);

    const { given_name, family_name, email } = tokenParsed;
    const first_name = capitalize(given_name);
    const last_name = capitalize(family_name);

    // console.log("first_name:", first_name);
    // console.log("last_name:", last_name);
    // console.log("email:", email);

    // Bail until the Tawk API is available
    if (!window.Tawk_API) return;

    window.Tawk_API.onLoad = () => {
      const attrs = { name: `${first_name} ${last_name}`, email };

      const trySetAttributes = (attempt) => {
        window.Tawk_API.setAttributes(attrs, (err) => {
          if (err) {
            if (attempt < 2) {
              console.warn(`[Tawk] setAttributes failed (attempt ${attempt}), retrying in 3s...`);
              setTimeout(() => trySetAttributes(attempt + 1), 3000);
            } else {
              console.error("[Tawk] setAttributes failed after retry:", err);
            }
          }
        });
      };

      trySetAttributes(1);
    };
  }, [tokenParsed]);

  return (
    <TawkMessengerReact
      propertyId="58707db72438f53b0a2585c1"
      widgetId="default"
    />
  );
};

export default TawkWrapper;
